import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface I_InterfaceFormMeta {
    ipAddress: FormInputMeta;
    interface: FormInputMeta;

}

const interfaceFormMeta = {} as I_InterfaceFormMeta;

interfaceFormMeta.ipAddress = {
    name: "ipAddress",
    type: "text",
    label: "Adresse IP",
    placeholder: "Adresse IP",
    validation: yup.string().required("Champ obligatoire !"),
};

interfaceFormMeta.interface = {
    name: "interface",
    type: "select",
    label: "Interface",
    validation: yup.string().required("Champ obligatoire !"),
};

export default interfaceFormMeta;